module.exports = __webpack_public_path__ + "media/components/NewAsset/icons/store-card-ead79a0188ad46a492732dec7813967a.svg";